// db.cows.update({name:/fine gent/i}, {$set:{
//   documents: {
//     fetility: {
//       src: 'https://s3.eu-west-2.amazonaws.com/media.beefbook.com/GoodBeef_Index_Options_P1.pdf'
//     },
//     health: {
//       src: 'https://s3.eu-west-2.amazonaws.com/media.beefbook.com/GoodBeef_Index_Options_P1.pdf'
//     },
//     grassFed: {
//       src: 'https://s3.eu-west-2.amazonaws.com/media.beefbook.com/GoodBeef_Index_Options_P1.pdf'
//     },
//     pedigree: {
//       src: 'https://s3.eu-west-2.amazonaws.com/media.beefbook.com/GoodBeef_Index_Options_P1.pdf'
//     },
//     ownership: {
//       src: 'https://s3.eu-west-2.amazonaws.com/media.beefbook.com/GoodBeef_Index_Options_P1.pdf'
//     },
//     purchasing: {
//       src: 'https://s3.eu-west-2.amazonaws.com/media.beefbook.com/GoodBeef_Index_Options_P1.pdf'
//     }
//   }
// }})

/* eslint-disable max-len */
const documentDefinitions = {
  fertility: {
    name: 'Fertility',
    adminName: 'BCVA bull pre breeding examination certificate',
    type: 'pdf',
    description: 'For assuring that the bull is fertile. Semen tested in accordance with the British Cattle Veterinary Association-prescribed examination',
    scores: ['fertility']
  },
  health: { // legacy
    name: 'Elite Health Accreditation',
    adminName: 'CHeCS elite health accreditation certificate',
    legacy: true,
    type: 'pdf',
    description: 'For the highest health. CHeCS (British Cattle Veterinary Association Health Certification Standards).'
  },
  checsPremium: {
    name: 'Premium Health Accreditation',
    adminName: 'CHeCS premium health accreditation certificate',
    type: 'pdf',
    farmLevel: true,
    description: 'For high health. CHeCS (British Cattle Veterinary Association Health Certification Standards).',
    scores: ['health']
  },
  checsElite: {
    name: 'Elite Health Accreditation',
    adminName: 'CHeCS elite health accreditation certificate',
    type: 'pdf',
    farmLevel: true,
    description: 'For the highest health. CHeCS (British Cattle Veterinary Association Health Certification Standards).',
    scores: ['health']
  },
  grassFed: {
    name: '100% Grass Fed',
    adminName: 'Pasture for Life certificate',
    type: 'pdf',
    farmLevel: true,
    description: '100% grass fed for taste, succulence and nutritional value. Pasture for Life Association, PFLA inspected and certified 100% pasture fed',
    scores: ['pastureVsGrain', 'pastureFed']
  },
  pedigree: {
    name: 'British Beef Heritage',
    adminName: 'Pedigree certificate',
    type: 'pdf',
    description: 'For eating quality. Aberdeen Angus Breeding Society genetic data',
    scores: ['breed']
  },
  ownership: {
    name: 'Passport',
    adminName: 'UK gov passport',
    type: 'pdf',
    description: 'For identification, breed, sire and dam and locations. UK Government official record and guarantee of ownership'
  },
  ahdb: {
    name: 'AHDB checklist',
    adminName: 'AHDB cattle purchasing checklist',
    type: 'pdf',
    description: 'For animal health and medical history. Record of any health issues to the knowledge of the farm vet',
    scores: ['homeBred']
  },
  redTractor: {
    name: 'High Welfare Standards',
    adminName: 'Red tractor documentation',
    type: 'pdf',
    farmLevel: true,
    description: 'For production excellence. Red Tractor (UK Defra/NFU trade cattle handling and bio-security assurance).',
    scores: ['welfare']
  },
  westCountryBeef: {
    name: 'West Country Beef',
    adminName: 'West country beef certificate',
    type: 'pdf',
    farmLevel: true,
    description: 'For provenance. recognising the South West of England\'s abundance of pastureland',
    scores: ['pgiStatus']
  },
  ultraSound: {
    name: 'Good Fat Cover & Colour',
    adminName: 'Ultrasound (IMF) readout',
    type: 'pdf',
    description: 'For superior eating quality. Ultra-sound tested, 7cm - 8cm average fat depth at rump and rib',
    scores: ['retailValue', 'fatCover', 'texture', 'flavour']
  },
  healthRecord: {
    name: 'Health Record',
    adminName: 'Farmplan health record',
    type: 'pdf',
    description: 'For a comprehensive picture of an animals health. Farmplan records show all health interventions and a history of the animals weight',
    scores: ['antibiotics', 'traceElements', 'medication']
  },
  organic: {
    name: 'Organic Certification',
    adminName: 'Organic Certification',
    type: 'pdf',
    farmLevel: true,
    description: 'Assurance of a process free from chemical pesticides and herbicides'
  }
};

export const buildDocumentArray = documentsObject =>
  Object.keys(documentsObject).filter(key => {
    return key !== 'fertility';
  }).map(key => ({
    ...documentDefinitions[key],
    src: documentsObject[key].src || '/',
    description: documentDefinitions[key].description || '',
    key
  }));

export default documentDefinitions;
